import classNames from 'classnames';
import {memo} from 'react';
import style from './style.module.scss';
import {ARROW_DIRECTION} from 'core/constants';
import {TArrowDirection, TPropsWithClassName} from 'core/types';
import {ARROW_SIZE, ARROW_TYPE} from 'components/icons/Arrow/constants';
import Icon from 'components/Icon';
import {TIconName} from 'components/Icon/iconNames';

interface IProps {
    size?: keyof typeof ARROW_SIZE;
    type?: keyof typeof ARROW_TYPE;
    direction?: TArrowDirection;
}
const ARROW_TO_SIZE = {
    [ARROW_SIZE.sm]: 'arrow-sm',
    [ARROW_SIZE.m]: 'arrow-m',
    [ARROW_SIZE.default]: 'arrow',
    [ARROW_SIZE.lg]: null,
    [ARROW_SIZE.xl]: null,
};
const CHEVRON_TO_SIZE = {
    [ARROW_SIZE.sm]: null,
    [ARROW_SIZE.m]: 'chevron-m',
    [ARROW_SIZE.default]: 'chevron',
    [ARROW_SIZE.lg]: null,
    [ARROW_SIZE.xl]: null,
};
const ARROW_PLAY_TO_SIZE = {
    [ARROW_SIZE.sm]: 'arrow-play-sm',
    [ARROW_SIZE.m]: 'arrow-play-m',
    [ARROW_SIZE.default]: 'arrow-play-m',
    [ARROW_SIZE.lg]: null,
    [ARROW_SIZE.xl]: null,
};
const ARROW_LINE_TO_SIZE = {
    [ARROW_SIZE.sm]: 'arrow-line-sm',
    [ARROW_SIZE.m]: null,
    [ARROW_SIZE.default]: 'arrow-line',
    [ARROW_SIZE.lg]: null,
    [ARROW_SIZE.xl]: null,
};
export const Arrow = memo<TPropsWithClassName<IProps>>(function Arrow({
    className,
    type = ARROW_TYPE.default,
    size = ARROW_SIZE.default,
    direction = ARROW_DIRECTION.down,
}) {
    const ARROW_TO_TYPE = {
        [ARROW_TYPE.line]: ARROW_LINE_TO_SIZE[size] || ARROW_LINE_TO_SIZE[ARROW_SIZE.default],
        [ARROW_TYPE.play]: ARROW_PLAY_TO_SIZE[size] || ARROW_PLAY_TO_SIZE[ARROW_SIZE.default],
        [ARROW_TYPE.default]: ARROW_TO_SIZE[size] || ARROW_TO_SIZE[ARROW_SIZE.default],
        [ARROW_TYPE.chevron]: CHEVRON_TO_SIZE[size] || CHEVRON_TO_SIZE[ARROW_SIZE.default],
    };
    const icon = ARROW_TO_TYPE[type];

    return (
        <Icon className={classNames(style.icon, style[direction], style[size], className)} icon={icon as TIconName} />
    );
});
